import React, { useState, useEffect } from 'react';
import _ from 'underscore';
import JBrowseService from '../services/jbrowse.service';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import {
  TextField,
  Button,
  Box,
  MenuItem,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControlLabel,
  Switch,
  Checkbox,
  Alert,
  AlertTitle,
  Backdrop,
  CircularProgress,
  Stack,
  ButtonGroup,
  ToggleButtonGroup,
  ToggleButton,
  Divider
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
  // Icon imports from @mui/icons-material
import {
    AutoAwesome as AutoAwesomeIcon,
    GridView as GridViewIcon,
    TableChart as TableChartIcon,
    Download as DownloadIcon,
    Dns as DnsIcon,
    FindInPage as FindInPageIcon,
    People as PeopleIcon,
    DeleteSweep as DeleteSweepIcon,
    CloudDownload as CloudDownloadIcon
  } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import { Widget, addResponseMessage, toggleWidget } from 'react-chat-widget';
import EventBus from '../common/EventBus';

// Socket.io
import socketIOClient from 'socket.io-client';
import socketUrl from '../common/GetSocket';
import { Redirect } from 'react-router-dom';
const ENDPOINT = socketUrl();

function AccessVariantsModal(props) {
  const {
    selectedVariants,
    setSelectedVariants,
    selectedAssembly,
    selectedTracks,
    location,
    currentUser,
    sequence,
    setSequence,
    setSequenceModalIsOpen,
    featureModalIsOpen,
    setFeatureModalIsOpen,
    accessVariantIsOpen,
    setAccessVariantIsOpen,
    setHaploData,
    setHaploModalIsOpen,
    setLoading,
    sampleNames,
    setSampleNames,
    setSampleSequenceIsOpen,
    setOpenAiModalIsOpen,
    selectedCrop,
    setConversation,
    setShowLiteratureSearch,
    setToggleLiteratureSearch,
    chromosomes,
    availableAssemblies,
    currentAssembly,
    setIsConversationModalOpen,
  } = props;

  const [spinner, setSpinner ] = useState(false);
  const [verinomicsSpinner, setVerinomicsSpinner ] = useState(false);
  const [currentType, setCurrentType] = useState('');
  const [sequenceBool, setSequenceBool] = useState(false);
  const [clearBool, setClearBool] = useState(false);
  const [accordionOpen, setAccordionOpen] = useState(null);
  const [localSelectedVariants, setLocalSelectedVariants] = useState([]);
  const [genBank, setGenBank] = useState(null);
  const [currentProject, setCurrentProject] = useState({ vcfs: [{ filePath: '' }] });
  const [showSpinner, setShowSpinner] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [openAiError, setOpenAiError] = useState(false);
  const [sizeWarning, setSizeWarning] = useState(false);
  const [assembly, setAssembly] = useState('');
  const [chromosome, setChromosome] = useState(chromosomes[0]);
  const [start, setStart] = useState('');
  const [stop, setStop] = useState('');
  const [panGenomes, setPanGenomes] = useState([]);

  // Toggles a panel on/off by name
  const handleAccordionChange = (panelName) => (event, isExpanded) => {
    setAccordionOpen(isExpanded ? panelName : false);
  };
  
  const setType = (type) => {
    setCurrentType(type);
    console.log(`Current type is now: ${type}`);
  };
  // Fade in/out effect replaced with a standard MUI Dialog & Backdrop
  // so we won't manually manage opacity.

  useEffect(() => {
    if (selectedVariants) {
      setLocalSelectedVariants(selectedVariants);
    }
  }, [selectedVariants]);

  useEffect(() => {
    const socket = socketIOClient(ENDPOINT);
    socket.on('haploviewer', (response) => {
      if (currentUser.email === response.email) {
        setLoading(false);

        const json = response.result;
        const result = [];
        _.each(json.z, function (value, key) {
          let s = value.toString();
          s = s.split('.').join('');
          s = s.split(',');
          const obj = {
            z: s,
            text: json.textArray[key],
            input: ''
          };
          result.push(obj);
        });

        const data = {
          x: json.x,
          y: json.y,
          z: json.z,
          combo: result,
          text: json.textArray,
          names: json.x.slice()
        };

        setHaploData(data);
        setAccessVariantIsOpen(false);
        setTimeout(() => {
          setHaploModalIsOpen(true);
        }, 100);
      }
    });
    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setAccessVariantIsOpen(false);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const clearOnClose = () => {
    setLocalSelectedVariants([]);
    if (clearBool) {
      setSelectedVariants([]);
    }
    setAccessVariantIsOpen(false);
  };

  const downloadGenBank = () => {
    setCurrentType('GenBank');
    const vcfFiles = selectedTracks.filter((file) => file.endsWith('.vcf'));
    const gffFiles = selectedTracks.filter((file) => file.endsWith('.gff'));
    const gff3Files = selectedTracks.filter((file) => file.endsWith('.gff3'));
    const gffs = gffFiles.concat(gff3Files);

    const obj = {
      vcf: vcfFiles.join(','),
      gff: gffs.join(','),
      ref: selectedAssembly,
      loc: location,
      size: extractDifference(location),
      user: currentUser.email
    };

    setGenBank(obj);
  };

  const downloadVariants = () => {
    setVerinomicsSpinner(true);

    if (currentType === 'GenBank') {
      if (genBank.size <= 100000) {
        genBank.user = currentUser.email;
        JBrowseService.downloadGenBank(genBank).then(
          (response) => {
            if (response.status === 0) {
              const filename = `VariantDownload.${currentType}.gbk`;
              setSuccessMessage('Successfully downloaded data!');
              setTimeout(() => setSuccessMessage(''), 3000);
              downloadFile(response.result, filename);
              setVerinomicsSpinner(false);
            } else {
              setErrorMessage('GenBank Request Error');
              setTimeout(() => setErrorMessage(''), 3000);
              setVerinomicsSpinner(false);
            }
          },
          (error) => {
            setErrorMessage('GenBank Request Error');
            setTimeout(() => setErrorMessage(''), 3000);
            setVerinomicsSpinner(false);
          }
        );
      } else {
        alert('You selected too large of a region, try again.');
        setVerinomicsSpinner(false);
      }
    } else {
      const vcfs = selectedTracks.filter((file) => file.endsWith('.vcf'));
      const obj = {
        variants: localSelectedVariants.join(','),
        vcf: vcfs[0],
        type: currentType,
        user: currentUser.email,
        company: currentUser.DirectoryName
      };

      if (!obj.variants) {
        setErrorMessage('Variant Warning Message');
        setTimeout(() => setErrorMessage(''), 3000);
        return;
      }

      const size = extractDifference(location);
      if (size >= 10000) {
        alert('You selected too large of a region, try again.');
        setVerinomicsSpinner(false);
      } else {
        JBrowseService.variantDownload(obj).then(
          (response) => {
            if (response.status === 0) {
              setSuccessMessage('Successfully downloaded data!');
              setTimeout(() => setSuccessMessage(''), 3000);

              let fileType = response.type;
              if (fileType === 'Excel') {
                fileType = 'csv';
                response.result = response.result.replace(/\t/g, ',');
              } else if (fileType === 'FastPhase') {
                fileType = 'phase.inp';
              }
              const filename = `VariantDownload.${fileType}`;
              downloadFile(response.result, filename);
              setVerinomicsSpinner(false);
            } else {
              setErrorMessage('Variant Error Message');
              setTimeout(() => setErrorMessage(''), 3000);
              setVerinomicsSpinner(false);
            }
          },
          () => {
            setVerinomicsSpinner(false);
          }
        );
      }
    }
  };

  const retrieveSequence = () => {
    const vcfFiles = selectedTracks.filter((file) => file.endsWith('.vcf'));
    setLoading(true);

    const obj = {
      annotated: sequenceBool,
      checked: sequenceBool,
      interval: 1000,
      locations: location,
      reference: selectedAssembly,
      vcf: vcfFiles[0],
      user: currentUser.email,
      company: currentUser.DirectoryName
    };

    JBrowseService.sequenceRetrieval(obj).then(
      (response) => {
        setSuccessMessage('Successfully found a sequence!');
        setTimeout(() => setSuccessMessage(''), 3000);
        if (sequenceBool) {
          const arr = response.result.split('\n');
          const sequenceObj = {
            loc: arr[0],
            sequence: arr[1]
          };
          const retrievalResponse = [sequenceObj];
          setSequence(retrievalResponse);
          setAccessVariantIsOpen(false);
          setTimeout(() => {
            setSequenceModalIsOpen(true);
            setLoading(false);
          }, 100);
        } else {
          const arr = response.result.split('\n');
          const dat = [];
          _.each(arr, function (value) {
            dat.push(value);
          });
          const samples = [];
          _.each(dat.slice(0, -1), (value) => {
            const fix = value.split('\t');
            const obj = {
              loc: fix[0],
              sequence: fix[1]
            };
            samples.push(obj);
          });
          setSequence(samples);
          setAccessVariantIsOpen(false);
          setTimeout(() => {
            setSequenceModalIsOpen(true);
            setLoading(false);
          }, 100);
        }
      },
      () => {
        setErrorMessage('An unexpected error occurred.');
        setTimeout(() => setErrorMessage(''), 3000);
        setLoading(false);
      }
    );
  };

  const showSelectSamples = () => {
    setLoading(true);
    const vcfFiles = selectedTracks.filter((file) => file.endsWith('.vcf'));
    const obj = {
      file: vcfFiles[0],
      ref: selectedAssembly,
      user: currentUser.email,
      company: currentUser.DirectoryName
    };
    JBrowseService.getSampleNames(obj).then(
      (response) => {
        setSampleNames(response.result.output);
        setAccessVariantIsOpen(false);
        setTimeout(() => {
          setSampleSequenceIsOpen(true);
          setLoading(false);
        }, 100);
      },
      () => {
        setLoading(false);
      }
    );
  };

  const openFeatureTableModal = () => {
    setAccessVariantIsOpen(false);
    setTimeout(() => {
      setFeatureModalIsOpen(true);
    }, 100);
  };

  const clearVariants = () => {
    setSelectedVariants([]);
  };

  const toggleClearVariants = () => {
    setClearBool(!clearBool);
  };

  const removeVariant = (index) => {
    const updatedVariants = [...localSelectedVariants];
    updatedVariants.splice(index, 1);
    setLocalSelectedVariants(updatedVariants);
  };

  const sequenceToggle = () => {
    setSequenceBool(!sequenceBool);
  };

  const buildHaploviewer = () => {
    setLoading(true);
    const vcfFiles = selectedTracks.filter((file) => file.endsWith('.vcf'));
    const obj = {
      variants: localSelectedVariants,
      vcf: vcfFiles[0],
      position: location,
      user: currentUser.email,
      company: currentUser.DirectoryName
    };
    JBrowseService.haploviewer(obj).then(
      () => {},
      (error) => {
        if (error.status === 401) {
          EventBus.dispatch('logout');
        }
      }
    );
  };

  const promptOpenAi = () => {
    setSpinner(true);
    const gffFiles = selectedTracks.filter((file) => file.endsWith('.gff'));
    const gff3Files = selectedTracks.filter((file) => file.endsWith('.gff3'));
    const gffs = gff3Files.concat(gffFiles);

    const obj = {
      location: location,
      crop: selectedCrop,
      assembly: selectedAssembly,
      gff: gffs[0],
      user: currentUser.email,
      company: currentUser.DirectoryName
    };
    const { start, stop } = parseLocationString(location);
    const size = stop - start;

    if (size >= 500000) {
      setSpinner(false);
      setSizeWarning(true);
      setTimeout(function () {
        setSizeWarning(false);
      }, 5000);
    } else {
      JBrowseService.gffOpenAiPrompt(obj).then(
        (response) => {
          toggleWidget();
          const prompt =
            'Describe the primary biological function of a gene using the provided list of Gene Ontology (GO) terms for a specific crop: ' +
            selectedCrop +
            ' and assembly:' +
            selectedAssembly +
            ". Focus on detailing the specific interactions and roles of the gene based on these GO terms. The description should be concise and strictly adhere to the functions indicated by the GO terms without implying the gene's importance or broader biological significance. Use only the most relevant GO terms and discard terms that are generic, ambiguous, or not relevant to the primary biological function. Your analysis should leverage the depth of information in the Go Terms to provide advanced interpretations suitable for an audience well-versed in bioinformatics. The description should be no longer than one short paragraph. The GO terms are: " +
            response.goTerms;
          const gff_prompt =
            'Given these lines from a gff file from crop: Tomato, and Assembley: S_lycopersicum_chromosomes.3.00 go through the "Attributes" tab and find interesting facts about this region. Your Response should refrain from using generic bioinformatic terms and instead tailor your insights to an advanced scientific audience with a solid understanding of bioinformatics, eschewing basic explanations in favor of more profound, nuanced interpretations that demonstrate a deep comprehension of the subject matter. gff lines: { ' +
            response.gffs +
            ' }';

          const convo = [
            {
              role: 'system',
              content:
                "You're role is a bioinformatics specalist and you task is to give detail about the agricultural data provided, be precise and concise."
            },
            {
              role: 'user',
              content: prompt + '\n' + gff_prompt
            },
            {
              role: 'assistant',
              content: response.result
            }
          ];
          setConversation(convo);
          addResponseMessage(response.result);
          setSpinner(false);
          setAccessVariantIsOpen(false);
          setShowLiteratureSearch(true);
          setToggleLiteratureSearch(false);
        },
        (error) => {
          setOpenAiError(true);
          setTimeout(() => {
            setOpenAiError(false);
          }, 3000);
          setSpinner(false);
        }
      );
    }
  };

  const handleChromosomeChange = (event) => {
    setChromosome(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    const vcfFiles = selectedTracks.filter((file) => file.endsWith('.vcf'));
    const obj = {
      starting: start,
      ending: stop,
      chromosome: chromosome,
      vcfs: vcfFiles,
      user: currentUser.email,
      company: currentUser.DirectoryName
    };

    JBrowseService.getVariants(obj).then(
      (response) => {
        if (isBlank(response.result)) {
          alert('no variants found.');
          setLoading(false);
          return;
        }
        const variants = response.result.split(',');
        setSelectedVariants(variants);
        setLoading(false);
      },
      (error) => {
        if (error.code === 'ERR_NETWORK') {
          EventBus.dispatch('logout');
        }
      }
    );
  };

  const getPanGenomes = (event) => {
    event.preventDefault();
    let obj = {
      user: currentUser.email,
      file: currentAssembly.name + '.fa',
      crop: selectedCrop
    };
    JBrowseService.getPanGenomes(obj).then(
      (response) => {
        setPanGenomes(response.result);
        setAccordionOpen(accordionOpen !== 'convert' ? 'convert' : null);
      },
      (error) => {
        if (error.code === 'ERR_NETWORK') {
          EventBus.dispatch('logout');
        }
      }
    );
  };

  const convertPositions = (event) => {
    event.preventDefault();
    let obj = {
      assembly: currentAssembly.name + '.fa',
      panGenome: assembly,
      position: `${chromosome}:${start}-${stop}`,
      user: currentUser.email,
      company: currentUser.DirectoryName
    };
    JBrowseService.convertPositions(obj).then(
      () => {
        setIsConversationModalOpen(true);
      },
      () => {}
    );
  };

  return (
    <>
      {/* Loading Backdrop */}
      <Backdrop open={showSpinner} sx={{ color: '#fff', zIndex: 9999 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Dialog
        open={accessVariantIsOpen}
        onClose={clearOnClose}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            backgroundColor: '#fff',
            boxShadow: '0px 0px 15px rgba(0,0,0,0.5)',
            borderRadius: '8px',
            maxHeight: '80vh'
          }
        }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6">
            <i className="fas fa-key" style={{ marginRight: '8px' }}></i> Access Variants
          </Typography>
          <IconButton onClick={clearOnClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ overflowY: 'auto' }}>
          {localSelectedVariants.length === 0 ? (
            <Box>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Select your preferred region to explore available variants.
              </Typography>
              {/* Form for picking region */}
              <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit}>
                {chromosomes && chromosomes.length > 0 && (
                  <TextField
                    select
                    label="Chromosome"
                    value={chromosome}
                    onChange={handleChromosomeChange}
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 2 }}
                  >
                    {chromosomes.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
                <TextField
                  required
                  id="start"
                  label="Start"
                  type="number"
                  value={start}
                  onChange={(e) => setStart(e.target.value)}
                  variant="outlined"
                  fullWidth
                  sx={{ mb: 2 }}
                />
                <TextField
                  required
                  id="stop"
                  label="Stop"
                  type="number"
                  value={stop}
                  onChange={(e) => setStop(e.target.value)}
                  variant="outlined"
                  fullWidth
                  sx={{ mb: 2 }}
                />
                <Button type="submit" variant="contained" color="primary">
                  Access Variants
                </Button>
              </Box>
            </Box>
          ) : (
            <Box>
              {/* If we have selected variants */}
              {/* Alerts */}
              {successMessage && (
                <Alert severity="success" sx={{ mb: 2 }}>
                  <AlertTitle>Success</AlertTitle>
                  {successMessage}
                </Alert>
              )}
              {errorMessage && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  <AlertTitle>Error</AlertTitle>
                  {errorMessage}
                </Alert>
              )}
              {openAiError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  <AlertTitle>Error</AlertTitle>
                  There was an error with the openAI servers, try again later.
                </Alert>
              )}
              {sizeWarning && (
                <Alert severity="warning" sx={{ mb: 2 }}>
                  <AlertTitle>Warning</AlertTitle>
                  Your selected region is too large for efficient AI analysis. Please select a smaller region.
                </Alert>
              )}

              <Box display="flex" gap={2}>
                {/* List of Variants */}
                <Box flex={1}>
                  <Typography variant="h6" align="center" sx={{ mt: 2 }}>
                    Selected Variants - {localSelectedVariants.length}
                  </Typography>
                  <Box
                    sx={{
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      p: 2,
                      maxHeight: '40vh',
                      overflowY: 'auto',
                      mt: 2
                    }}
                  >
                    {localSelectedVariants.map((variant, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          mb: 1
                        }}
                      >
                        <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                          {variant}
                        </Typography>
                        <Button variant="contained" color="error" size="small" onClick={() => removeVariant(index)}>
                          Remove
                        </Button>
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* Actions */}
                <Box flex={1} sx={{ p: 2, bgcolor: 'background.paper', borderRadius: 2 }}>
                    <Typography
                        variant="h6"
                        align="center"
                        sx={{
                            mb: 3,
                            // color: 'primary.main',
                            fontWeight: 'medium',
                            letterSpacing: 1
                        }}
                    >
                        Variant Actions
                    </Typography>

                    <Stack spacing={2} sx={{ width: '100%' }}>
                      <FormControl fullWidth>
                        <Button
                          variant="contained"
                          fullWidth
                          startIcon={<AutoAwesomeIcon />}
                          onClick={promptOpenAi}
                          aria-describedby="analysis-helper-text"
                          sx={{
                            py: 1.5,
                            bgcolor: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                            '&:hover': { bgcolor: 'primary.dark' }
                          }}
                        >
                          AI Agents Analysis
                        </Button>
                        <FormHelperText
                          id="analysis-helper-text"
                          sx={{ color: 'text.secondary', textAlign: 'center', mt: 1 }}
                        >
                          We will use GoTerms and GFF lines to analyze this region using AI agents
                        </FormHelperText>
                      </FormControl>

                        <ButtonGroup fullWidth variant="outlined">
                            <Button
                                startIcon={<GridViewIcon />}
                                onClick={buildHaploviewer}
                                sx={{ flexGrow: 1 }}
                            >
                                Haploviewer
                            </Button>
                            <Button
                                startIcon={<TableChartIcon />}
                                onClick={openFeatureTableModal}
                                sx={{ flexGrow: 1 }}
                            >
                                Feature Table
                            </Button>
                        </ButtonGroup>

                        {/* Export Data Accordion */}
                        <Accordion
                            expanded={accordionOpen === 'download'}
                            onChange={handleAccordionChange('download')}
                            elevation={0}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                sx={{ bgcolor: 'action.hover', borderRadius: 1 }}
                            >
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <DownloadIcon color="primary" />
                                    <Typography variant="subtitle1">Export Data</Typography>
                                </Stack>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Stack spacing={2}>
                                    <ToggleButtonGroup
                                        exclusive
                                        value={currentType}
                                        fullWidth
                                        sx={{ gap: 1 }}
                                    >
                                        {['VCF', 'Excel', 'FastPhase', 'GenBank'].map((type) => (
                                            <ToggleButton
                                                key={type}
                                                value={type}
                                                onClick={() =>
                                                    type === 'GenBank' ? downloadGenBank() : setType(type)
                                                }
                                                sx={{
                                                    flex: 1,
                                                    textTransform: 'none',
                                                    borderWidth: 2,
                                                    '&.Mui-selected': { borderWidth: 2 }
                                                }}
                                            >
                                                {type}
                                            </ToggleButton>
                                        ))}
                                    </ToggleButtonGroup>

                                    <Button
                                        variant="contained"
                                        startIcon={<CloudDownloadIcon />}
                                        onClick={downloadVariants}
                                        disabled={!currentType}
                                        fullWidth
                                    >
                                        Download {currentType || 'File'}
                                    </Button>
                                </Stack>
                            </AccordionDetails>
                        </Accordion>

                        {/* Sequence Retrieval Accordion */}
                        <Accordion
                            expanded={accordionOpen === 'retrieve'}
                            onChange={handleAccordionChange('retrieve')}
                            elevation={0}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                sx={{ bgcolor: 'action.hover', borderRadius: 1 }}
                            >
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <DnsIcon color="primary" />
                                    <Typography variant="subtitle1">Sequence Retrieval</Typography>
                                </Stack>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Stack spacing={2}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={sequenceBool}
                                                onChange={sequenceToggle}
                                                color="secondary"
                                            />
                                        }
                                        label="Include Annotations"
                                        sx={{ '& .MuiFormControlLabel-label': { typography: 'body2' } }}
                                    />

                                    <Button
                                        variant="outlined"
                                        onClick={retrieveSequence}
                                        startIcon={<FindInPageIcon />}
                                        fullWidth
                                    >
                                        Retrieve Sequence
                                    </Button>

                                    <Divider sx={{ my: 1 }} />

                                    <Button
                                        variant="text"
                                        onClick={showSelectSamples}
                                        startIcon={<PeopleIcon />}
                                        sx={{ color: 'text.secondary' }}
                                    >
                                        Manage Sample Selection
                                    </Button>
                                </Stack>
                            </AccordionDetails>
                        </Accordion>

                      <Button
                        variant="text"
                        sx={{
                          color: 'grey', // Text color
                          '&:hover': {
                            backgroundColor: '#f5f5f5', // Light grey background on hover
                          },
                        }}
                        startIcon={<DeleteSweepIcon />}
                        onClick={clearVariants}
                      >
                        Clear All Variants
                      </Button>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={clearBool}
                                    onChange={toggleClearVariants}
                                    // color="error"
                                />
                            }
                            label={
                                <Typography 
                                  variant="body2" 
                                  // color="error"
                                >
                                    Auto-clear on exit
                                </Typography>
                            }
                            sx={{ ml: 0.5 }}
                        />
                    </Stack>
                </Box>


              </Box>
            </Box>
          )}
          {spinner && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ fontStyle: 'italic' }}
              >
                Awaiting response from OpenAI...
              </Typography>
            </div>
          )}

          {verinomicsSpinner && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ fontStyle: 'italic' }}
              >
                Awaiting response from Verinomics servers...
              </Typography>
            </div>
          )}
          

        </DialogContent>

        <DialogActions>
          <Button onClick={clearOnClose} variant="outlined" color="inherit">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AccessVariantsModal;

function isBlank(str) {
  return !str || /^\s*$/.test(str);
}

function extractDifference(str) {
  const numbers = str.split(':').pop();
  const [start, end] = numbers.split('-').map(Number);
  return end - start;
}

function downloadFile(data, filename) {
  if (!data) {
    return;
  }
  if (!filename) {
    filename = 'download.json';
  }
  if (typeof data === 'object') {
    data = JSON.stringify(data, undefined, 2);
  }
  const blob = new Blob([data], { type: 'text/json' });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const e = document.createEvent('MouseEvents');
    const a = document.createElement('a');
    a.download = filename;
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
    e.initEvent('click', true, false);
    a.dispatchEvent(e);
  }
}

function parseLocationString(locationStr) {
  const parts = locationStr.split(/[:\-]/);
  return {
    chromosome: parts[0],
    start: parseInt(parts[1], 10),
    stop: parseInt(parts[2], 10)
  };
}
